import { createBrowserRouter, Link } from 'react-router-dom';
import { Layout } from './components/Layout';

// Inline NotFound component
function NotFound() {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4 py-16">
      <h1 className="text-6xl font-bold text-[#12233a] mb-4" style={{ fontFamily: 'Cinzel, serif' }}>
        404
      </h1>
      <h2 className="text-2xl font-semibold text-[#1a2b3c] mb-6" style={{ fontFamily: 'Montserrat, sans-serif' }}>
        Page Not Found
      </h2>
      <p className="text-[#1a2b3c]/80 mb-8 max-w-md">
        Looks like this page took a walk! Let's get you back on track.
      </p>
      <Link
        to="/"
        className="bg-[#c8a96a] text-[#12233a] px-6 py-3 rounded-full font-semibold hover:bg-[#b89860] transition-colors"
      >
        Return to Home
      </Link>
    </div>
  );
}

export const router = createBrowserRouter([
  {
    path: '/',
    Component: Layout,
    children: [
      { 
        path: 'admin', 
        lazy: async () => ({ Component: (await import('./pages/AdminPortal')).default }) 
      },
      { 
        index: true, 
        lazy: async () => ({ Component: (await import('./pages/Home')).Home }) 
      },
      { 
        path: 'about', 
        lazy: async () => ({ Component: (await import('./pages/About')).About }) 
      },
      { 
        path: 'services', 
        lazy: async () => ({ Component: (await import('./pages/Services')).Services }) 
      },
      { 
        path: 'booking', 
        lazy: async () => ({ Component: (await import('./pages/Booking')).Booking }) 
      },
      { 
        path: 'contact', 
        lazy: async () => ({ Component: (await import('./pages/Contact')).Contact }) 
      },
      { 
        path: 'login', 
        lazy: async () => ({ Component: (await import('./pages/Auth')).Auth }) 
      },
      { 
        path: 'pet-profile', 
        lazy: async () => ({ Component: (await import('./pages/PetProfile')).PetProfile }) 
      },
      { 
        path: '*', 
        Component: NotFound 
      },
    ],
  },
]);
